<template>
  	<div class="rightBlock ligthTabC">

		<div class="tab" style="display: block;width: 100%;">

			<child-bottonProductc ref="childBottonProductc"></child-bottonProductc>

			<div class="channel">
				<div tip style='position: absolute;top: -40px; color: #9c9c9c'>
					{{$t("ligthTab.ligthInfo")}}
					
					<el-button v-on:click="setButtonRGB('000000')" round size="mini" type="info" plain>{{$t("performanceTab.rest")}}</el-button>
					<el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
					<el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
					<el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button>
					<el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
				</div>

				<div left>
					<!-- <p fun>
						<i>旋转木马</i> <span sty></span>
					</p> -->

					<el-select v-model="valMode" @change="setMode" placeholder="旋转木马">
						<el-option v-for="item in modeList" :key="item.valMode" style="width: 290px;"
						  :label="item.name"
						  :value="item.valMode">
						</el-option>
					  </el-select>


					<ul ligthList>
						<li>
							<i>{{$t("ligthTab.ligth")}}</i>
							<el-slider @change="setBrightness" max="4"  v-model="brightness" :marks="brightnessMarks"></el-slider>
						</li>
						<li class="speedBlock">
							<i>{{$t("ligthTab.speed")}}</i>
							<el-slider @change="setSpeed"  max="4" v-model="speed" :marks="speedMarks"></el-slider>
						</li>
					</ul>
				</div>
				
				<div mid>
					<div class="color_select">
						<ul colorList>
							<li @click="setStaticRGB" color="ff0000" class="light"></li>
							<li @click="setStaticRGB" color="00ff00" class="light"></li>
							<li @click="setStaticRGB" color="0000ff" class="light"></li>
							<li @click="setStaticRGB" color="ffff00" class="light"></li>
							<li @click="setStaticRGB" color="ff00ff" class="light"></li>
							<li @click="setStaticRGB" color="FF7D00" class="light"></li>
							
							<li @click="setStaticRGB" color="a74b98" class="light"></li>
							<li @click="setStaticRGB" color="e50c84" class="light"></li>
							<li @click="setStaticRGB" color="f5a400" class="light"></li>
							<li @click="setStaticRGB" color="9ecd7a" class="light"></li>
		
							<li @click="setStaticRGB" color="71c8e1" class="light"></li>
							<li @click="setStaticRGB" color="ff08b1" class="light"></li>
							<li @click="setStaticRGB" color="ff866b" class="light"></li>

							<li @click="setStaticRGB" color="7BFF00" class="light"></li>
						</ul>
		
						<div class="editRGB upRGB">
							R:<input class="r" type="number" @keyup.enter="confirmValue"  v-model.number="R" min="0" max="255" @input="vaiteValR" />
							G:<input class="g" type="number" @keyup.enter="confirmValue"  v-model.number="G" min="0" max="255" @input="vaiteValG" />
							B:<input class="b" type="number" @keyup.enter="confirmValue"  v-model.number="B" min="0" max="255" @input="vaiteValB" />
						</div>
		
						<el-select v-model="valChild" @change="setModeChild" :placeholder="this.$i18n.t('defineData.ligths.MODE1')">
							<el-option v-for="item in modeList[valTempMode].child" :key="item.valChild" style="width: 290px;"
							  :label="item.name"
							  :value="item.valChild">
							</el-option>
						</el-select>
		
					</div>
		
				</div>
		
				<div right>

					<el-color-picker v-model="colors" @change="pickerRGB"></el-color-picker>
		
				</div>

			</div>
		</div>

	</div>

</template>


<script>
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
import { ToolsHandle } from '../../../../utils/tools.js';

import bottonProductC from './buttonTabPane/ligthProduct.vue'
export default {
  name: 'journeyTabC',
  components: 
  {
	'child-bottonProductc':bottonProductC
  },
  data() 
  {
    return {
	  HIDDeviceObj:null,
	  R:255,
	  G:255,
	  B:255,
	  colors: null,
	  valMode:1,
	  valTempMode:1,
	  valChild:1,
	  modeList:
	  [
		{
			"name":this.$i18n.t("defineData.ligths.L00"),
			"valMode":-1,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L0"),
			"valMode":0,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L1"),
			"valMode":1,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L2"),
			"valMode":2,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L3"),
			"valMode":3,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L4"),
			"valMode":4,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L5"),
			"valMode":5,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L6"),
			"valMode":6,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L7"),
			"valMode":7,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L8"),
			"valMode":8,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L9"),
			"valMode":9,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L10"),
			"valMode":10,
			"type":0,
			"child":
			[
			{
				"name":this.$i18n.t("defineData.ligths.MODE1"),
				"valChild":1
			},
			{
				"name":this.$i18n.t("defineData.ligths.MODE2"),
				"valChild":3
			}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L11"),
			"valMode":11,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L12"),
			"valMode":12,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L13"),
			"valMode":13,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L14"),
			"valMode":14,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L15"),
			"valMode":15,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L16"),
			"valMode":16,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L17"),
			"valMode":17,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L18"),
			"valMode":18,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L19"),
			"valMode":19,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L20"),
			"valMode":20,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		},
		{
			"name":this.$i18n.t("defineData.ligths.L21"),
			"valMode":21,
			"type":0,
			"child":
			[
				{
					"name":this.$i18n.t("defineData.ligths.MODE1"),
					"valChild":1
				},
				{
					"name":this.$i18n.t("defineData.ligths.MODE2"),
					"valChild":3
				}
			]
		}
	  ],
	  brightness:3,
	  brightnessMarks: 
	  {
		  0: '',
          1: '',
          2: '',
          3: '',
		  4: ''
	  },
	  speed:4,
	  speedMarks: 
	  {
		  0: '',
          1: '',
          2: '',
          3: '',
		  4: ''
	  }
    }
  },
  mounted()
  {
	var context = this;

	// this.modeList = cmd10.PRGBLIST;
	this.brightness = parseInt(cmd10.PRGBBRIGHTNESS,16);
	this.speed = parseInt(cmd10.PRGBSPEED,16);

  },
  updated: function () 
  {
	this.valTempMode = this.valMode == -1 ? 1:this.valMode;
  },
  methods:
  {
	init()
	{
		const 	ChildBottonProductC = this.$refs.childBottonProductc;
				ChildBottonProductC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
				ChildBottonProductC.HIDDeviceObj = this.HIDDeviceObj;
            	ChildBottonProductC.setProductImagePath();

	},
	//读取灯光数据
	async readLigth()
    {
		this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});

		cmd10.SET_DEVICE_PRGB_CMD[4] = "0x00";
		//写入硬件
		const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

		await ToolsHandle.delay(50);

		this.valMode = parseInt(this.HIDDeviceObj.modeLigth,16);
		this.brightness = parseInt(this.HIDDeviceObj.brightnessLigth,16);
		this.speed = parseInt(this.HIDDeviceObj.speedLigth,16);

		this.$notify.closeAll();
	},
	setModeChild(index)
	{
		this.brightness = index == -1?0:this.brightness;
		this.brightness = index != -1 && this.brightness == 0 ?4:this.brightness;

		cmd10.SET_DEVICE_PRGB_CMD[4] = "0x01";
		cmd10.SET_DEVICE_PRGB_CMD[41] = index.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[42] = this.brightness.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[43] = this.valMode.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[44] = this.speed.toString(16);

		//写入硬件
		const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

		this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
	},
	setMode(index)
	{
		this.brightness = index == -1?0:this.brightness;
		this.brightness = index != -1 && this.brightness == 0 ?4:this.brightness;

		cmd10.SET_DEVICE_PRGB_CMD[4] = "0x01";
		cmd10.SET_DEVICE_PRGB_CMD[41] = this.valChild.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[42] = this.brightness.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[43] = index.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[44] = this.speed.toString(16);

		//写入硬件
		const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

		this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
	},
	setBrightness(val)
	{
		cmd10.SET_DEVICE_PRGB_CMD[4] = "0x01";
		cmd10.SET_DEVICE_PRGB_CMD[41] = this.valChild.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[42] = this.brightness.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[43] = this.valMode.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[44] = this.speed.toString(16);

		//写入硬件
		const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

		this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
	},
	setSpeed(val)
	{
		cmd10.SET_DEVICE_PRGB_CMD[4] = "0x01";
		cmd10.SET_DEVICE_PRGB_CMD[40] = index == -1?0:3;
		cmd10.SET_DEVICE_PRGB_CMD[41] = index == -1?0:this.valChild.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[42] = this.brightness.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[43] = index.toString(16);
		cmd10.SET_DEVICE_PRGB_CMD[44] = this.speed.toString(16);

		//写入硬件
		const outputReportData = new Uint8Array(cmd10.SET_DEVICE_PRGB_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

		this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
	},
	vaiteValR(el)
	{
		let min = el.target.getAttribute("min");
		let max = el.target.getAttribute("max");
		let value = el.target.value;

		if(parseInt(value)<parseInt(min))
		{
			this.R = min;
		}
		else if(parseInt(value)>parseInt(max))
		{
			this.R = max;
		}
	},
	vaiteValG(el)
	{
		let min = el.target.getAttribute("min");
		let max = el.target.getAttribute("max");
		let value = el.target.value;

		if(parseInt(value)<parseInt(min))
		{
			this.G = min;
		}
		else if(parseInt(value)>parseInt(max))
		{
			this.G = max;
		}
	},
	vaiteValB(el)
	{
		let min = el.target.getAttribute("min");
		let max = el.target.getAttribute("max");
		let value = el.target.value;

		if(parseInt(value)<parseInt(min))
		{
			this.B = min;
		}
		else if(parseInt(value)>parseInt(max))
		{
			this.B = max;
		}
	},
	setStaticRGB(el)
	{
		let rgbs = document.querySelectorAll('.color_select li');
			rgbs.forEach(function(el) 
			{
				el.classList.remove('on');
			});
		el.target.classList.add('on');

		//设置
		let rgbVal = el.target.getAttribute("color");
		this.setButtonRGB(rgbVal);
	},
	confirmValue()
	{
		let rgbVal = this.R.toString(16) + this.G.toString(16) + this.B.toString(16);
		this.setButtonRGB(rgbVal);
	},
	pickerRGB()
	{
		let rgbVal = this.colors.replace("#","");
		this.setButtonRGB(rgbVal);
	},
	async setButtonRGB(rgb)
	{

		this.valMode = 21;
		//写入硬件开始
		const outputReportData1 = new Uint8Array(cmd10.SET_CUSTOM_BUTTON_MODE_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData1);
		await ToolsHandle.delay(200);

		//获取设置对象
		let buttons = document.querySelectorAll('.ligthTabC li.select');
			buttons = buttons.length == 0? document.querySelectorAll('.ligthTabC li'):buttons;

		let commandButtonRGBGroups =  this.HIDDeviceObj.getButtonRGBCommand(buttons,rgb,cmd10);

		let outputReportData2 = [];
		for(let i in commandButtonRGBGroups)
		{
			await ToolsHandle.delay(100);
			//写入硬件
			outputReportData2 = new Uint8Array(commandButtonRGBGroups[i].map(hex => parseInt(hex, 16)));
			this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData2);
		}

		await ToolsHandle.delay(300);
		//写入硬件结束
		
		outputReportData2[5] = "0xfe";
		outputReportData2[6] = "0xfe";
		outputReportData2[7] = "0xfe";
		outputReportData2[8] = "0xfe";
		// const outputReportData3 = new Uint8Array(cmd10.SET_CUSTOM_BUTTON_RGB_END_CMD.map(hex => parseInt(hex, 16)));
		this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData2);

		this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
	},
	//选择按键
	buttonSelect(op)
    {
      switch(op)
      {
        case 'cancel':
        {
          let buttons = document.querySelectorAll('.ligthTabC li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });

        }break;
        case 'wasd':
        {
          let buttons = document.querySelectorAll('.ligthTabC li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonW = document.querySelector('.ligthTabC li[name="W"]');
          let buttonA = document.querySelector('.ligthTabC li[name="A"]');
          let buttonS = document.querySelector('.ligthTabC li[name="S"]');
          let buttonD = document.querySelector('.ligthTabC li[name="D"]');
          
              buttonW.classList.add('select');
              buttonA.classList.add('select');
              buttonS.classList.add('select');
              buttonD.classList.add('select');
          
        }break;
        case 'ud':
        {
          let buttons = document.querySelectorAll('.ligthTabC li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonU = document.querySelector('.ligthTabC li[name="Up"]');
          let buttonD = document.querySelector('.ligthTabC li[name="Down"]');
          let buttonL = document.querySelector('.ligthTabC li[name="Left"]');
          let buttonR = document.querySelector('.ligthTabC li[name="Right"]');

          if(buttonU == null)
          {
            this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
            return;
          }


          buttonU.classList.add('select');
          buttonD.classList.add('select');
          buttonL.classList.add('select');
          buttonR.classList.add('select');

        }break;
        case 'wasdud':
        {

          let buttons = document.querySelectorAll('.ligthTabC li');
              buttons.forEach(function(el) 
              {
                  el.classList.add('select');
              });

          // let buttonCW = document.querySelector('.perfBP li[name="W"]');
          // let buttonCA = document.querySelector('.perfBP li[name="A"]');
          // let buttonCS = document.querySelector('.perfBP li[name="S"]');
          // let buttonCD = document.querySelector('.perfBP li[name="D"]');
          
          // buttonCW.classList.add('select');
          // buttonCA.classList.add('select');
          // buttonCS.classList.add('select');
          // buttonCD.classList.add('select');


          // let buttonU = document.querySelector('.perfBP li[name="UP"]');
          // let buttonD = document.querySelector('.perfBP li[name="DOWN"]');
          // let buttonL = document.querySelector('.perfBP li[name="LEFT"]');
          // let buttonR = document.querySelector('.perfBP li[name="RIGHT"]');

          // if(buttonU == null)
          // {
          //   this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
          //   return;
          // }

          // buttonU.classList.add('select');
          // buttonD.classList.add('select');
          // buttonL.classList.add('select');
          // buttonR.classList.add('select');

        }break;

      }

    },

  }
}

</script>